module.exports = "/images/line-lg.png?2183528d6b8d86c7ae1090baed979e7f";